<template>
  <v-dialog
    v-model="openDialogExisteInscripcion"
    max-width="480"
    persistent
    content-class="estado-inscripcion-dialog"
  >
    <v-card class="overflow-hidden">
      <!-- Header con ícono y título según estado -->
      <v-card-title class="pa-4 pb-2 headline" :class="headerClass">
        <v-icon large left class="mr-2">{{ headerIcon }}</v-icon>
        {{ headerTitle }}
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-4 pt-3">
        <p class="body-1 mb-4 grey--text text--darken-1" v-if="mensajeCorto">
          {{ mensajeCorto }}
        </p>

        <!-- Inscripción expirada: MP o transferencia (misma decisión, distinto contexto) -->
        <div v-if="esExpirada" class="mb-4">
          <v-card flat class="pa-3 red lighten-5" style="border: 1px solid rgba(244, 67, 54, 0.4); border-radius: 8px;">
            <p v-if="usaPagoOnline" class="body-2 mb-2 grey--text text--darken-2">
              Tu pago con Mercado Pago expiró. Podés reactivar la misma inscripción y obtener un nuevo link de pago, o bien modificar datos o la carrera y volver a completar el formulario.
            </p>
            <p v-else class="body-2 mb-2 grey--text text--darken-2">
              Tu inscripción por transferencia o depósito había vencido. Podés reactivarla para tener un nuevo plazo y subir el comprobante, o bien modificar datos o la carrera y volver a completar el formulario.
            </p>
            <p v-if="modalidadInscripcionNombre" class="body-2 mb-2">
              <span class="grey--text text--darken-2">Se reactivará la inscripción en:</span>
              <strong>{{ modalidadInscripcionNombre }}</strong>
            </p>
            <v-alert
              v-if="remeraSoloPuedeModificar"
              type="warning"
              :value="true"
              class="mb-3"
              outline
            >
              <span class="body-2">{{ remeraSinStockMensaje }}</span>
            </v-alert>
            <p v-else class="caption mb-3 grey--text text--darken-1">
              Si reactivás sin cambiar datos, el cupón de descuento se conserva si todavía es válido. La remera puede quitarse si no hay stock del talle elegido.
            </p>
            <v-btn
              v-if="!remeraSoloPuedeModificar"
              color="red darken-2"
              block
              dark
              class="mb-2"
              @click="volverAInscribirme"
            >
              <v-icon left small>{{ usaPagoOnline ? 'payment' : 'refresh' }}</v-icon>
              {{ usaPagoOnline ? 'Reactivar sin cambiar mis datos (nuevo link MP)' : 'Reactivar sin cambiar mis datos' }}
            </v-btn>
            <v-btn
              color="primary"
              block
              outline
              @click="modificarReinscripcion"
            >
              <v-icon left small>edit</v-icon>
              Modificar datos o la carrera
            </v-btn>
          </v-card>
        </div>

        <div v-else-if="usaPagoOnline && esPendiente" class="mb-4">
          <v-card flat class="pa-3 orange lighten-5" style="border: 1px solid rgba(255, 152, 0, 0.4); border-radius: 8px;">
            <p class="body-2 mb-3 grey--text text--darken-2">
              Completá el pago para confirmar tu inscripción.
            </p>
            <template v-if="mercadoPagoInitPoint">
              <v-btn
                :href="mercadoPagoInitPoint"
                target="_blank"
                rel="noopener noreferrer"
                block
                color="#009ee3"
                dark
                class="mb-2"
              >
                <v-icon left small>payment</v-icon>
                Pagar en Mercado Pago
              </v-btn>
              <p class="body-2 grey--text text--darken-2 caption">
                Serás redirigido a Mercado Pago para completar el pago de forma segura.
              </p>
            </template>
            <template v-else>
              <p class="body-2 grey--text text--darken-2">
                Si tu link de pago expiró, hacé clic en "Volver a inscribirme" para obtener un nuevo link.
              </p>
              <v-btn
                color="primary"
                block
                @click="volverAInscribirme"
              >
                <v-icon left small>refresh</v-icon>
                Volver a inscribirme
              </v-btn>
            </template>
          </v-card>
        </div>

        <div v-else-if="usaPagoOnline" class="mb-4">
          <v-card flat class="pa-3 blue-grey lighten-5" style="border: 1px solid rgba(96, 125, 139, 0.4); border-radius: 8px;">
            <p class="body-2 mb-3 grey--text text--darken-2">
              Para inscribirte en este evento con pago online, completá el formulario nuevamente.
            </p>
            <v-btn
              color="primary"
              block
              @click="volverAInscribirme"
            >
              <v-icon left small>edit</v-icon>
              Volver a inscribirme
            </v-btn>
          </v-card>
        </div>

        <div v-else-if="esPendiente" class="mb-4">
          <v-card flat class="pa-3 orange lighten-5" style="border: 1px solid rgba(255, 152, 0, 0.4); border-radius: 8px;">
            <p class="body-2 mb-3 grey--text text--darken-2">
              Completá el pago para confirmar tu inscripción.
            </p>
            <template v-if="comprobanteAccessToken">
              <p class="body-2 mb-3 grey--text text--darken-2">
                Si pagaste por transferencia o depósito, subí el comprobante para que podamos acreditar tu pago.
              </p>
              <v-btn
                block
                color="orange darken-2"
                dark
                :to="'/comprobante/' + comprobanteAccessToken"
              >
                <v-icon left small>cloud_upload</v-icon>
                Subir comprobante de pago
              </v-btn>
            </template>
            <template v-else>
              <p class="body-2 grey--text text--darken-2">
                {{ mensajeCorto || 'Tenés una inscripción pendiente.' }}
              </p>
            </template>
          </v-card>
        </div>

        <div v-else-if="esConfirmada" class="mb-2">
          <p class="body-2 grey--text text--darken-2">
            Tu inscripción ya está confirmada. No tenés que hacer nada más.
          </p>
        </div>

        <div v-else class="mb-2">
          <p class="body-2 grey--text text--darken-2" v-if="existe_inscripcion_msg">
            {{ existe_inscripcion_msg }}
          </p>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4 pt-3">
        <v-spacer />
        <v-btn flat color="grey darken-1" @click="closeDialog">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EstadoInscripcionDialog',
  props: {
    openDialogExisteInscripcion: {
      type: Boolean,
      default: false
    },
    existe_inscripcion_msg: {
      type: String,
      default: ''
    },
    inscripcion_state: {
      type: String,
      default: ''
    },
    mercadoPagoInitPoint: {
      type: String,
      default: null
    },
    comprobanteAccessToken: {
      type: String,
      default: null
    },
    usaPagoOnline: {
      type: Boolean,
      default: false
    },
    modalidadInscripcionNombre: {
      type: String,
      default: ''
    },
    remeraSoloPuedeModificar: {
      type: Boolean,
      default: false
    },
    remeraSinStockMensaje: {
      type: String,
      default: ''
    }
  },
  computed: {
    headerClass() {
      if (this.usaPagoOnline && this.esExpirada) return 'red lighten-4';
      if (this.usaPagoOnline) return 'blue-grey lighten-4';
      if (this.esConfirmada) return 'green lighten-4';
      if (this.esExpirada) return 'red lighten-4';
      if (this.esPendiente) return 'orange lighten-4';
      return 'grey lighten-3';
    },
    headerIcon() {
      if (this.usaPagoOnline && this.esExpirada) return 'schedule';
      if (this.usaPagoOnline) return 'info';
      if (this.esConfirmada) return 'check_circle';
      if (this.esExpirada) return 'schedule';
      if (this.esPendiente) return 'payment';
      return 'info';
    },
    headerTitle() {
      if (this.usaPagoOnline && this.esExpirada) return 'Tu pago expiró';
      if (this.usaPagoOnline) return 'Inscripción existente';
      if (this.esConfirmada) return 'Inscripción confirmada';
      if (this.esExpirada) return 'Inscripción vencida';
      if (this.esPendiente) return 'Pago pendiente';
      return 'Estado de inscripción';
    },
    mensajeCorto() {
      if (this.esExpirada) return null;
      if (this.usaPagoOnline) return 'Ya tenés una inscripción para este evento.';
      if (this.esConfirmada) return null;
      if (this.esPendiente) return 'Tenés una inscripción pendiente de pago.';
      return this.existe_inscripcion_msg || null;
    },
    esPendiente() {
      return this.inscripcion_state === 'pago_pendiente';
    },
    esExpirada() {
      return this.inscripcion_state === 'pago_expirado';
    },
    esConfirmada() {
      return this.inscripcion_state === 'pago_realizado' || this.inscripcion_state === 'pago_bonificado';
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialogExisteInscripcion');
    },
    volverAInscribirme() {
      this.$emit('volverAInscribirme');
    },
    modificarReinscripcion() {
      this.$emit('elegirModificarReinscripcion');
    }
  }
};
</script>

<style scoped>
.estado-inscripcion-dialog >>> .v-card__title {
  word-break: normal;
}
</style>
